export default function anonymous(props
) {
var out='<div class="'+(props.styles.loader)+' '+(props.styles.active)+'" data-playable-component data-playable-hook="loader" ></div>';return out;
}